var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9313_1578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3506 14.3299L10.3136 2.15292C9.89893 1.42757 8.97478 1.17569 8.24943 1.59032C8.01506 1.7243 7.8208 1.91855 7.68683 2.15292L0.649782 14.3299C0.380798 14.8003 0.38389 15.3786 0.657889 15.846C0.923056 16.3214 1.42693 16.6138 1.97125 16.6081H16.0291C16.5735 16.6138 17.0773 16.3214 17.3425 15.846C17.6165 15.3786 17.6196 14.8003 17.3506 14.3299ZM9.00123 15.5353C8.1713 15.5381 7.49622 14.8676 7.49341 14.0377C7.4906 13.2078 8.16112 12.5327 8.99106 12.5299C9.82099 12.5271 10.4961 13.1976 10.4989 14.0275C10.5017 14.8574 9.83117 15.5325 9.00123 15.5353C9.00124 15.5353 9.00123 15.5353 9.00123 15.5353ZM9.89778 11.511C9.8733 11.6089 9.8157 11.6953 9.73477 11.7556C9.67123 11.797 9.59667 11.8183 9.52082 11.8167H9.44951C9.15283 11.7657 8.84964 11.7657 8.55296 11.8167C8.45356 11.8332 8.35159 11.8114 8.26769 11.7556C8.18676 11.6953 8.12917 11.6089 8.10468 11.511C7.79988 9.98806 7.59905 8.4461 7.50358 6.89584C7.50407 6.06872 8.17498 5.39858 9.0021 5.39907C9.82855 5.39955 10.4984 6.0694 10.4989 6.89584C10.4034 8.4461 10.2026 9.98806 9.89778 11.511Z",
    fill: "#FFC100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9313_1578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.298f4d14376af39641cba13dd0518ed8.svg";
export { ForwardRef as ReactComponent };